'use client'
import { cx } from '../utils'
import { Button } from './Button'

export function Pagination({
  page,
  pageCount,
  total,
  onChange,
}: {
  page: number
  pageCount: number
  total: number
  onChange: (page: number) => void
}) {
  const pages = Array.from({ length: pageCount }, (_, i) => i + 1)
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mt-[30px] sticky bottom-0 bg-canvas py-2 border-t border-line">
      <p className="font-mono text-[13px] text-ink-3">
        {total} 条记录 · 第 {page}/{Math.max(pageCount, 1)} 页
      </p>
      <div className="flex items-center gap-1">
        <Button size="sm" disabled={page <= 1} onClick={() => onChange(page - 1)}>
          上一页
        </Button>
        {pages.map((p) => (
          <button
            key={p}
            onClick={() => onChange(p)}
            aria-current={p === page ? 'page' : undefined}
            className={cx(
              'pxs-focus h-7 min-w-7 rounded-xs border px-1.5 font-mono text-[14px] transition-colors duration-100',
              p === page
                ? 'border-accent bg-accent-fill text-white shadow-[0_1px_2px_rgba(194,101,42,0.2)]'
                : 'border-line-strong bg-surface text-ink-2 shadow-[var(--shadow-xs)] hover:bg-accent-soft hover:text-ink',
            )}
          >
            {p}
          </button>
        ))}
        <Button size="sm" disabled={page >= pageCount} onClick={() => onChange(page + 1)}>
          下一页
        </Button>
      </div>
    </div>
  )
}
